import { render } from "./Confetti.vue?vue&type=template&id=785a13ed&scoped=true"
import script from "./Confetti.vue?vue&type=script&lang=js"
export * from "./Confetti.vue?vue&type=script&lang=js"

import "./Confetti.vue?vue&type=style&index=0&id=785a13ed&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-785a13ed"]])

export default __exports__